import { render, staticRenderFns } from "./gardeners.vue?vue&type=template&id=4813d530&scoped=true"
import script from "./gardeners.vue?vue&type=script&lang=js"
export * from "./gardeners.vue?vue&type=script&lang=js"
import style0 from "./gardeners.vue?vue&type=style&index=0&id=4813d530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4813d530",
  null
  
)

export default component.exports